// Resolve image URLs. Backend uploads return /api/files/... — prepend backend host.
const BACKEND = process.env.REACT_APP_BACKEND_URL || "";
export const imgSrc = (u) => {
  if (!u) return "";
  if (u.startsWith("http://") || u.startsWith("https://")) return u;
  if (u.startsWith("/api/")) return `${BACKEND}${u}`;
  return u;
};
